import { useCallback, useEffect, useState } from 'react';
import Axios from '@/utils/Axios';
import { getUrlAPI } from '@/utils/Path';

export default function useApiGet(url: string) {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  async function load(apiUrl: string) {
    if (!apiUrl || apiUrl.trim() === '') {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const res = await Axios.get(getUrlAPI(apiUrl));
      setData(res.data?.payload);
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }

  const handleRefresh = useCallback(() => {
    if (!url || url.trim() === '') {
      return;
    }

    load(url);
  }, [url]);

  useEffect(() => {
    if (!url || url.trim() === '') {
      setLoading(false);
      return;
    }

    const handler = setTimeout(() => {
      load(url);
    }, 200);

    return () => {
      clearTimeout(handler);
    };
  }, [url]);

  return { data, error, loading, handleRefresh };
}
